import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },

  {
    path: '/:slug',
    name: 'universe',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Universe'),
  },

  {
    path: '/:slug/:char',
    name: 'character',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Character'),
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
